import * as React from "react"
import ElemCheckboxMafo from "../../elements/CheckboxMafo"

interface MafoQuestionProps {
	register: Function
	errors: any
	watch: Function
	setValue: Function
}
const MafoQuestionOne: React.FC<MafoQuestionProps> = ({ register, errors, watch, setValue }) => {
	const questionOneValue = watch("question1")
	const hasOtherOptionSelected = Array.isArray(questionOneValue) ? questionOneValue.includes("h") : questionOneValue === "h"

	React.useEffect(() => {
		if (!hasOtherOptionSelected) {
			setValue("question1Other", "")
		}
	}, [hasOtherOptionSelected, setValue])

	return (
		<>
			<h3 className="mafo-headline text-left text-blue">1. Warum hast Du TREK Protein Bars zum ersten Mal gekauft?
(Mehrfachauswahl möglich)
</h3>
			<div className="mx-auto text-left lg:max-w-[100%] pt-1">
				<ElemCheckboxMafo label={<>Ich probiere grundsätzlich gerne neue Produkte aus.</>}  className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="a"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Wegen der Geld-zurück-Aktion.</>} className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="b"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Weil ich Biscoff-Produkte kenne und mag.</>} className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="c"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Weil ich generell gerne neue Müsliriegel oder Proteinriegel ausprobiere.</>} className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="d"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Weil mich die Kombination aus pflanzlichem Protein und natürlichen Zutaten anspricht.</>} className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="e"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Weil ich die Produkte auf einem Aufsteller oder Display gesehen habe.</>} className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="f"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Ich habe TREK bereits zuvor gekauft (z. B. online oder im Ausland).</>} className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="g"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				<ElemCheckboxMafo label={<>Sonstiges</>} className=" question1 pb-2 text-blue">
					<input
						type="checkbox"
						{...register("question1")}
						name="question1"
						required="required"
						value="h"
						className={"peer absolute hidden h-1 w-1 " + (errors.question1 ? " js-formerror " : "")}
					/>
				</ElemCheckboxMafo>
				{hasOtherOptionSelected && (
					<>
						<textarea {...register("question1Other")} name="question1Other" maxLength={99} className="h-[150px] w-full bg-[#F7F7F7] py-4 px-2 border-blue border-[1px]"></textarea>
					</>
				)}
			</div>
		</>
	)
}

export default MafoQuestionOne
